/**
 * Query keys a ticket-state change must invalidate: the attendee table, and an open ticket's History and details.
 * The page's own ticket mutations and the host's switch / refund replies (`useHostTicketBridge`) both use it.
 */
export const TICKET_STATE_INVALIDATE_KEYS = [['responses'], ['ticket-history'], ['ticket-details']];
